export const WORDS = [
  'fecha',
  'ahora',
  'amigo',
  'juego',
  'banco',
  'enero',
  'feliz',
  'fruta',
  'huevo',
  'nunca',
  'joven',
  'nuevo',
  'falda',
  'serio',
  'junio',
  'lunes',
  'pollo',
  'playa',
  'queso',
  'silla',
  'verde',
  'abril',
  'sucio',
  'clase',
  'perro',
  'papel',
  'julio',
  'falso',
  'cinco',
  'ellas',
  'gorra',
  'manos',
  'oreja',
  'oveja',
  'elote',
  'viejo',
  'guapo',
  'leche',
  'mucho',
  'monos',
  'padre',
  'fuego',
  'salsa',
  'nieve',
  'barco',
  'tarea',
  'usted',
  'traje',
  'calle',
  'burro',
  'dedos',
  'fotos',
  'aires',
  'corro',
  'altos',
  'grita',
  'arena',
  'texto',
  'selva',
  'baila',
  'habla',
  'plato',
  'obvio',
  'nueve',
  'meses',
  'lejos',
  'viven',
  'lento',
  'islas',
  'busca',
  'hasta',
  'estoy',
  'zorro',
  'tenis',
  'suave',
  'miras',
  'bates',
  'final',
  'hacer',
  'pagan',
  'hotel',
  'nadan',
  'igual',
  'mayor',
  'norte',
  'dicen',
  'siete',
  'cerdo',
  'comer',
  'entra',
  'hielo',
  'pongo',
  'lavar',
  'madre',
  'peces',
  'rubia',
  'traen',
  'tener',
  'primo',
  'video',
  'damos',
  'beber',
  'ritmo',
  'salir',
  'quien',
  'puedo',
  'piano',
  'orden',
  'nubes',
  'ganan',
  'poema',
  'rojas',
  'peras',
  'nariz',
  'tomar',
  'miedo',
  'llave',
  'kilos',
  'ideas',
  'libro',
  'grupo',
  'abrir',
  'nadie',
  'gordo',
  'libre',
  'mejor',
  'largo',
  'error',
  'ayuda',
  'chile',
  'entre',
  'flojo',
  'gafas',
  'gallo',
  'leyes',
  'magia',
  'pedir',
  'reina',
  'somos',
  'tarde',
  'mosca',
  'tocar',
  'menor',
  'verbo',
  'wafle',
  'fresa',
  'mesas',
  'gatos',
  'lindo',
  'venir',
  'viaje',
  'canta',
  'abajo',
  'mujer',
  'donde',
  'dulce',
  'brazo',
  'dieta',
  'bueno',
  'vamos',
  'pavos',
  'museo',
  'marzo',
  'cacto',
  'tonto',
  'gente',
  'saben',
  'noche',
  'calor',
  'reloj',
  'vemos',
  'clima',
  'cuida',
  'flaco',
  'menos',
  'vacas',
  'trece',
  'broma',
  'poeta',
  'listo',
  'vuelo',
  'letra',
  'dolor',
  'salta',
  'abeja',
  'pobre',
  'cielo',
  'pecho',
  'mango',
  'sirve',
  'cabra',
  'secar',
  'carro',
  'regla',
  'rotos',
  'sexto',
  'cable',
  'tiran',
  'mapas',
  'crees',
  'suelo',
  'lleno',
  'pared',
  'horas',
  'solar',
  'votar',
  'techo',
  'velas',
  'subir',
  'globo',
  'ranas',
  'besos',
  'curso',
  'actor',
  'secos',
  'tigre',
  'boxeo',
  'llora',
  'luces',
  'bajar',
  'caros',
  'autor',
  'ducha',
  'cajas',
  'plata',
  'nevar',
  'valle',
  'bolsa',
  'rumor',
  'papas',
  'cenan',
  'mover',
  'bello',
  'parar',
  'honor',
  'vacio',
  'color',
  'monta',
  'parte',
  'vende',
  'drama',
  'llego',
  'cosas',
  'basta',
  'pasar',
  'cruzo',
  'frito',
  'ganso',
  'horno',
  'tazas',
  'nieto',
  'novia',
  'plaza',
  'rollo',
  'toros',
  'flota',
  'local',
  'punto',
  'turno',
  'unido',
  'crear',
  'ruido',
  'formo',
  'ideal',
  'notas',
  'radio',
  'legal',
  'rural',
  'favor',
  'actua',
  'botas',
  'copia',
  'mismo',
  'momia',
  'pausa',
  'hojas',
  'actos',
  'viaja',
  'pulpo',
  'tacos',
  'pisos',
  'milla',
  'rosas',
  'ambos',
  'metal',
  'disco',
  'todos',
  'sufre',
  'hijos',
  'valor',
  'causa',
  'carne',
  'llevo',
  'motor',
  'frase',
  'salas',
  'blusa',
  'quito',
  'camas',
  'medio',
  'crema',
  'sopas',
  'echar',
  'carta',
  'junto',
  'codos',
  'solos',
  'casas',
  'tango',
  'labio',
  'locos',
  'veces',
  'gusto',
  'nacer',
  'campo',
  'estas',
  'taxis',
  'dudan',
  'andar',
  'vasos',
  'curva',
  'renta',
  'justo',
  'cines',
  'morir',
  'patos',
  'clave',
  'bajos',
  'banda',
  'vista',
  'raros',
  'arroz',
  'tubas',
  'volar',
  'peine',
  'anual',
  'caras',
  'panes',
  'pesar',
  'circo',
  'voces',
  'cocos',
  'reyes',
  'queda',
  'curar',
  'filas',
  'sonar',
  'debes',
  'tutor',
  'claro',
  'pican',
  'humor',
  'sacar',
  'jefes',
  'yogur',
  'coral',
  'poder',
  'caigo',
  'hecho',
  'marca',
  'tenor',
  'colas',
  'falta',
  'dejar',
  'mundo',
]
